var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pt-8 pb-4 flex"},[_c('OSkeleton',{staticClass:"mr-4",attrs:{"width":"38px","height":"38px"}}),_vm._v(" "),_c('OSkeleton',{attrs:{"width":"200px","height":"40px","rounded":false}})],1),_vm._v(" "),_c('OSkeleton',{staticClass:"ml-18",attrs:{"width":"80px","height":"20px","rounded":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }